import React from 'react';
import { ContentTiles, ContentTilesProps } from '@noths/polaris-client-ribbons-design-system';

import { BlockContainer } from '../BlockContainer/BlockContainer';
import * as styles from './ContentTilesBlock.style';

export const ContentTilesBlock = (props: ContentTilesProps) => (
  <BlockContainer wrapperStyles={styles.wrapper} maxWidth="full" columnsXL={10}>
    <ContentTiles {...props} />
  </BlockContainer>
);

export type { ContentTilesProps };
